import React from "react"
import { Moon, Sun } from "lucide-react"
import { LayoutModeTypes } from "@/enums/layout"

interface LightDarkProps {
  layoutMode: LayoutModeTypes
  onChangeLayoutMode: (mode: LayoutModeTypes) => void
}

const LightDark: React.FC<LightDarkProps> = ({
  layoutMode,
  onChangeLayoutMode,
}) => {
  const mode =
    layoutMode === LayoutModeTypes.DARKMODE
      ? LayoutModeTypes.LIGHTMODE
      : LayoutModeTypes.DARKMODE

  return (
    <div className="ms-1 header-item d-none d-sm-flex">
      <button
        onClick={() => onChangeLayoutMode(mode)}
        type="button"
        className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle light-dark-mode"
      >
        {layoutMode === LayoutModeTypes.DARKMODE ? <Sun size={22} /> : <Moon size={22} />}
      </button>
    </div>
  )
}

export default LightDark
